export default "__VITE_ASSET__CRbTV2rp__"